import { jsx as _jsx } from "react/jsx-runtime";
import { Close } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
import { tailwindMerge } from "@air/tailwind-variants";
import { memo } from "react";
export const InputClearButton = /*#__PURE__*/ memo((param)=>{
    let { isVisible, isFlex = false, onClick, "data-testid": testId } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: tailwindMerge("flex h-full w-6 flex-col items-center justify-center", isFlex ? undefined : "absolute right-1.5 top-0", isVisible ? "pointer-events-auto opacity-100" : "pointer-events-none opacity-0"),
        children: /*#__PURE__*/ _jsx(IconButton, {
            label: "Clear",
            "data-testid": testId,
            appearance: "ghost",
            color: "grey",
            icon: Close,
            size: "small",
            onClick: onClick
        })
    });
});
InputClearButton.displayName = "InputClearButton";
